import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { useSearch } from '@tanstack/react-router';

import { Tooltip } from 'components/common/Tooltip';
import { IconPause, IconPlay } from 'components/icons';
import { useAspenLogger } from 'hooks/useAspenLogger';

interface PlayPauseProps {
  playing: boolean;
  disabled?: boolean;
  togglePlaying: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PlayPause = ({ playing, disabled = false, togglePlaying }: PlayPauseProps) => {
  const { eventId } = useSearch({ from: '/events' });
  const { logAspenEvent } = useAspenLogger();

  const getTooltipTitle = () => {
    if (disabled) return 'Video is being processed';
    if (playing) return 'Pause';
    return 'Play';
  };

  return (
    <Tooltip title={getTooltipTitle()} placement="top">
      <IconButton
        aria-label="play-pause"
        data-testid="button-play-pause"
        disabled={disabled}
        onClick={(e) => {
          if (disabled) return;

          if (eventId) {
            logAspenEvent({
              log_id: 'iot.web.event.interaction',
              payload: {
                event_id: eventId,
                interaction: playing ? 'pause' : 'play',
              },
            });
          }

          togglePlaying(e);
        }}
        sx={{
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:disabled': {
            opacity: 0.5,
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {playing ? <IconPause sx={{ color: colors.grey[400] }} /> : <IconPlay sx={{ color: colors.grey[400] }} />}
      </IconButton>
    </Tooltip>
  );
};
